export function resolveCallbackUrl(scope: ParentNode): string | null {
  const configured = scope.querySelector<HTMLElement>('[data-callback-url]')?.dataset.callbackUrl;
  if (!configured) {
    return null;
  }

  try {
    const url = new URL(configured, document.location.origin);
    if (url.origin !== document.location.origin) {
      return null;
    }

    url.search = '';
    url.hash = '';

    return url.toString();
  } catch {
    return null;
  }
}
